import { render, staticRenderFns } from "./CameraGalleryList.vue?vue&type=template&id=5a210c28&scoped=true&"
import script from "./CameraGalleryList.vue?vue&type=script&lang=ts&"
export * from "./CameraGalleryList.vue?vue&type=script&lang=ts&"
import style0 from "./CameraGalleryList.vue?vue&type=style&index=0&id=5a210c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a210c28",
  null
  
)

export default component.exports